import { z } from 'zod';
import { Company } from '../client';
import { makeEvent } from './EventBase';

export const CompanyUpdated = makeEvent(
    'CompanyUpdated',
    z.object({
        data: Company,
    }),
);

export type CompanyUpdated = (typeof CompanyUpdated)['schema']['_output'];
